import React, { PropTypes } from 'react';

const { bool, number, object, oneOfType, string } = PropTypes;

const StatItem = ({ disabled, statName, statValue, statNameStyle, stateValueStyle, style }) => (
  <div style={style}>
    <h4 style={Object.assign({}, { color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px', fontWeight: '400', lineHeight: '16px', marginBottom: '10px', padding: 0, textTransform: 'uppercase' }, statNameStyle)}>{statName}</h4>
    <h5 style={Object.assign({}, { fontSize: '48px', fontWeight: '500', lineHeight: '48px', margin: 0, padding: 0, marginBottom: '15px' }, stateValueStyle)}>{!disabled ? statValue : 0}</h5>
  </div>
);

StatItem.propTypes = {
  disabled: bool,
  statName: string.isRequired,
  statValue: oneOfType([
    string,
    number,
  ]).isRequired,
  statNameStyle: object,
  stateValueStyle: object,
};

export default StatItem;



// WEBPACK FOOTER //
// ./src/app/components/dashboard/StatItem.jsx